/**
 * 自增类型进制转换
 */

export function baseConversion(lookup, number) {
    let n = number;
    let str = '';
    for (const i in lookup) {
        if (Object.prototype.hasOwnProperty.call(lookup, i)) {
            while (n >= lookup[i]) {
                str += i;
                n -= lookup[i];
            }
        }
    }
    return str;
}

/**
 * office 客户端支持0-19 之后用数字代替
 * @param index
 * @returns {*}
 */
export function convertCircleNum(index) {
    if (index > 20) {
        return index.toString();
    }
    return CIRCLE_UNICODE_MAP[index];
}

export const CIRCLE_UNICODE_MAP = {
    1: '①',
    2: '②',
    3: '③',
    4: '④',
    5: '⑤',
    6: '⑥',
    7: '⑦',
    8: '⑧',
    9: '⑨',
    10: '⑩',
    11: '⑪',
    12: '⑫',
    13: '⑬',
    14: '⑭',
    15: '⑮',
    16: '⑯',
    17: '⑰',
    18: '⑱',
    19: '⑲',
    20: '⑳',
};

export const ROMAN_CAP = {
    M: 1000,
    CM: 900,
    D: 500,
    CD: 400,
    C: 100,
    XC: 90,
    L: 50,
    XL: 40,
    X: 10,
    IX: 9,
    V: 5,
    IV: 4,
    I: 1,
};

export const ROMAN_LOW_CASE = {
    m: 1000,
    cm: 900,
    d: 500,
    cd: 400,
    c: 100,
    xc: 90,
    l: 50,
    xl: 40,
    x: 10,
    ix: 9,
    v: 5,
    iv: 4,
    i: 1,
};

export const CAP = (function () {
    const o = {};
    for (let i = 90; i >= 65; i--) {
        o[String.fromCharCode(i)] = i - 64;
    }
    return o;
}());

export const LOWCASE = (function () {
    const o = {};
    for (let i = 122; i >= 97; i--) {
        o[String.fromCharCode(i)] = i - 96;
    }
    return o;
}());

export const CHINESE = {
    五百: 500,
    四百: 400,
    三百: 300,
    二百: 200,
    百: 100,
    九十: 90,
    八十: 80,
    七十: 70,
    六十: 60,
    五十: 50,
    四十: 40,
    三十: 30,
    二十: 20,
    十: 10,
    九: 9,
    八: 8,
    七: 7,
    六: 6,
    五: 5,
    四: 4,
    三: 3,
    二: 2,
    一: 1,
};
